import { render, staticRenderFns } from "./index--form.vue?vue&type=template&id=ebe2961c&scoped=true&"
import script from "./index--form.vue?vue&type=script&lang=js&"
export * from "./index--form.vue?vue&type=script&lang=js&"
import style0 from "./index--form.vue?vue&type=style&index=0&id=ebe2961c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebe2961c",
  null
  
)

export default component.exports